// @flow
import { postCreator } from '../../../http';
import environment from '../../../environment';

const endpoints = Object.freeze({
  PUT_PASSWORD: `${environment.apiUrl}/auth/password`,
});

export const putPasswordApi = postCreator(fetch, endpoints.PUT_PASSWORD);



// WEBPACK FOOTER //
// ./src/modules/preferences/password/api.js